export const LOGIN_ROUTES = [
  '/login',
  '/confirm',
  '/sandbox',
  '/create-sandbox',
  '/signup',
  '/register',
  '/forgot-password',
  '/reset-password'
] as const;

type LoginRouteType = (typeof LOGIN_ROUTES)[number];

export const LOGIN_ALLOWED_WITH_AUTH: LoginRouteType[] = [
  '/sandbox',
  '/confirm'
];

export const isRouteAnonymous = (route: string) => {
  return LOGIN_ROUTES.includes(route as LoginRouteType);
};

export const shouldDenyEntryForAuthedUser = (route: string) => {
  return (
    LOGIN_ROUTES.includes(route as LoginRouteType) &&
    !LOGIN_ALLOWED_WITH_AUTH.includes(route as LoginRouteType)
  );
};
